export default __webpack_public_path__ + "static/media/transaction-report.ec3e18e5.png";